import React, { useState, useCallback, useEffect } from 'react'
import Radio from './radio'
import Input from './input'
import api from '../api/api'


function renderText(element){
  return element.name
}
const driveTypes =[
  {
    text:"Roundtrip",
    value: true
  },
  {
    text:"One way",
    value: false
  }
]


function DrivingItinerary({index, itinerary, onChange, onDelete}) {
  const { distance, invalid} = itinerary;
  
  const [fromDriving, setFromDriving] = useState('')
  const [toDriving, setToDriving] = useState('')
  const fromValue = itinerary.fromDriving;
  const toValue = itinerary.toDriving;
  const driveType = itinerary.driveType;
  const calculate = useCallback((from, to, dt)=>{
    console.log(from, to)
    if(from.name && to.name){
      api.getDistance(from.name, to.name)
      .then((response)=>{
        const newDistance = Number(response.data)
        if(newDistance<=0){
          return onChange(index,{fromDriving: from, toDriving: to, distance:0, invalid:newDistance, driveType: dt})    
        }
        if(!isNaN(newDistance)){          
          
          onChange(index,{fromDriving: from, toDriving: to, 
            distance: dt==0? newDistance *2 : newDistance,
            driveType: dt, 
          invalid:1})      
        }      
      });
    }else{
      onChange(index,{fromDriving: from, toDriving: to, distance:0, invalid:1, driveType: dt})    
    }
  },[onChange, index])

  useEffect(()=>{
    if(itinerary.fromDriving){
      setFromDriving(itinerary.fromDriving.name)
    }
    if(itinerary.toDriving){
      setToDriving(itinerary.toDriving.name)
    }
  }, [itinerary])
  return (
    <div>
      
      {index!=0?(
        <div className="section-title">
          Enter additional driving details 
          <span onClick={()=>onDelete(index)} className="selectable" aria-hidden="true">&times;</span>
        </div>        
      ):null}
      <div className="form">
        <Input 
          label="From" 
          value={fromDriving} 
          renderText={renderText}
          autocompleteFunc={api.getAutocompletePlaces} 
          onChange={setFromDriving}
          onSelect={value=> {
            //onChange(index,{fromDriving:value, toDriving:toValue, distance, invalid, driveType},false) ;
            calculate(value, toValue, driveType);
          }}
          onBlur={()=> calculate()} 
          invalid={invalid == 0 || invalid==-2  || invalid ==-3}
          invalidText={
            invalid!=0?
            "Invalid location try again using zipcode"
            :""
          }/>
        <Input 
          label="To" 
          value={toDriving} 
          renderText={renderText}
          onChange={setToDriving}
          autocompleteFunc={api.getAutocompletePlaces} 
          onSelect={value=> {
            //onChange(index,{toDriving:value, fromDriving: fromValue, distance, invalid, driveType},false);
            calculate(fromValue,value, driveType );
          }}
          onBlur={()=> calculate()} 
          invalid={invalid==0 || invalid == -1 || invalid==-3}
          invalidText="Invalid location try again using zipcode"
          /> 
        <Radio selected={driveType} options={driveTypes} 
          onChange={value=> {
            //onChange(index,{toDriving:value, fromDriving: fromValue, distance, invalid, driveType:value},false);
            calculate(fromValue,toValue, value  );
          }}/>            
      </div>
    </div>

  )


}


export default DrivingItinerary